<nav *ngIf="numbers.length > 1">
    <ul class="pagination justify-content-center">
    <li id="prev" class="page-item" [ngClass]="{ 'disabled': options.page === 1 }">
        <span class="page-link"  (click)="prev()">{{"grid.previous" | translate}}</span>
    </li>
    <ng-container>
        <li class="page-item" *ngFor="let number of numbers" [ngClass]="{ 'active': options.page === number }">
        <span class="page-link"  (click)="to(number)">{{number}}</span>
        </li>
    </ng-container>
    <li id="next" class="page-item" [ngClass]="{ 'disabled': options.page === numbers.length }">
        <span class="page-link"  (click)="next()" disabled="true">{{"grid.next" | translate}}</span>
    </li>
    </ul>
</nav>